import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { setUserFromToken } from '../../redux/AuthSlice/authSlice';
import api from '../../api/axios';

const OAuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const error = params.get('error');
        const isNewUser = params.get("isNewUser") === "true";

        // "Connect Google" rejected because the chosen account didn't match the
        // logged-in email. The user is still logged in (no token issued) — send
        // them to Profile with a clear message.
        if (error === 'google_email_mismatch') {
            toast.error('That Google account doesn’t match your account email. Please connect the Google account you signed in with.');
            navigate('/profile');
            return;
        }

        if (token) {
            dispatch(setUserFromToken(token))
                .unwrap()
                .then(() => {
                    // Refer & Earn: OAuth signups can't carry the ?ref= code in the
                    // signup body, so the Signup page stashes it in localStorage and
                    // we attribute it here once the new account is authenticated.
                    if (isNewUser) {
                        try {
                            const ref = localStorage.getItem('cc_referral');
                            if (ref) {
                                api.post('/api/referrals/claim', { ref })
                                    .catch(() => { /* attribution is best-effort */ });
                                localStorage.removeItem('cc_referral');
                            }
                        } catch { /* ignore */ }
                    }
                    // Tell other open tabs (e.g. an in-progress email draft) to refresh
                    // their auth state — picks up the new Google connection without a reload.
                    try { localStorage.setItem('cc:auth-sync', String(Date.now())); } catch { /* ignore */ }
                    navigate("/", { state: { showOnboardingModal: isNewUser } });
                })
                .catch((err) => {
                    console.error("Error decoding token or setting user", err);
                    navigate("/login");
                });
        } else {
            navigate("/login");
        }
    }, [location.search, dispatch, navigate]);

    return <p>Logging you in...</p>;
};

export default OAuthCallback;
